import UserLogin from '../../../components/Login/UserLogin';
import './log-in.scss';

export default function Login() {
  return (
    <main className="LOGIN__PAGE">
      <div className="LOGIN__PAGE__BRAND" aria-hidden="true">
        <div className="LOGIN__PAGE__BRAND__LOGO">
          <span className="LOGIN__PAGE__BRAND__TRI">tri</span>
          <span className="LOGIN__PAGE__BRAND__DOT">.</span>
          <span className="LOGIN__PAGE__BRAND__LI">li</span>
          <span className="LOGIN__PAGE__BRAND__DOT">.</span>
          <span className="LOGIN__PAGE__BRAND__RI">ri</span>
          <span className="LOGIN__PAGE__BRAND__DOT">.</span>
          <span className="LOGIN__PAGE__BRAND__VOS">vos</span>
        </div>
        <p className="LOGIN__PAGE__BRAND__TAGLINE">
          where words find their place
        </p>
        <p className="LOGIN__PAGE__BRAND__DESCRIPTOR">
          A publishing platform for long-form writing, discovery, and meaningful
          conversation.
        </p>
      </div>
      <div className="LOGIN__PAGE__FORM__WRAPPER">
        <UserLogin />
      </div>
    </main>
  );
}
